import * as React from 'react'

interface ThunderboltIconProps {
    className?: string
    title?: string
}

/**
 * Thunderbolt icon for Level of Specification indicator
 */
const ThunderboltIcon: React.FC<ThunderboltIconProps> = ({
    className = '',
    title = 'Level of Specification indicator',
}) => (
    <svg
        width={11}
        height={13}
        viewBox="0 0 11 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-labelledby="thunderbolt-icon-title"
        focusable="false"
    >
        <title id="thunderbolt-icon-title">{title}</title>
        <path
            d="M0.75 7.09615L6.47727 0.75L5.25 5.40385H9.75L4.02273 11.75L5.25 7.09615H0.75Z"
            stroke="#555555"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ThunderboltIcon
